import { Box } from '@mui/material';
import Header from './components/Header';
import Content from './components/Content';
import Footer from './components/Footer';

const ActivityCenterTasksPanel = ({
  tasks,
  onClose,
  onClear,
  hasCompletedTasks
}) => (
  <Box sx={{ width: '100%', maxHeight: 500 }}>
    <Header onClose={onClose} />
    <Content tasks={tasks} />
    <Footer onClear={onClear} hasCompletedTasks={hasCompletedTasks} />
  </Box>
);

export default ActivityCenterTasksPanel;
